// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ImpactNavButton-cls1__baadbc38f342507c71ad{/*!*/}.ImpactNavButton-cls2__d87502e9d75d49334474{position:relative}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "ImpactNavButton-cls1__baadbc38f342507c71ad",
	"cls2": "ImpactNavButton-cls2__d87502e9d75d49334474 ImpactNavButton-cls1__baadbc38f342507c71ad"
};
export default ___CSS_LOADER_EXPORT___;
